import type { CSSProperties, ReactNode } from 'react';
import BlurText from '../../effects/BlurText/BlurText';
import Grain from '../../effects/Grain/Grain';
import styles from './PageHero.module.css';

interface PageHeroProps {
    title: string;
    lead?: string;
    backdrop?: ReactNode;
    children?: ReactNode;
}

function longestWordLength(text: string): number {
    return Math.max(...text.split(' ').map((word) => word.length));
}

export default function PageHero({ title, lead, backdrop, children }: PageHeroProps) {
    return (
        <section className={styles.hero} data-theme="dark" aria-labelledby="page-title">
            {backdrop}
            <Grain />
            <div className={`page-inner ${styles.content}`} style={{ '--longest-word': longestWordLength(title) } as CSSProperties}>
                <BlurText as="h1" id="page-title" text={title} className={styles.title} stepMs={110} />
                {lead && <p className={styles.lead}>{lead}</p>}
                {children}
            </div>
        </section>
    );
}
